export enum SubscriptionError {
  unknown = 'unknown',
  unable_to_create_subscription = 'unable_to_create_subscription',
  unable_to_apply_discount = 'unable_to_apply_discount',
}
